import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { TrainingClassDetailIndexPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { SessionsDataTable } from './SessionsDatatable'

const SessionsTab = () => {
  const { classId, id } = useParams()
  const { canEdit } = useOutletContext<{ canEdit: boolean }>()
  const { data } = useQuery(TrainingClassDetailIndexPageDocument, {
    variables: { trainingClassId: Number(classId) },
  })

  const currentClass = data?.trainings.trainingClass ?? undefined
  return (
    <Box>
      <SessionsDataTable trainingClassId={Number(classId)} trainingId={Number(id)} />
      <Outlet context={{ canEdit, currentClass, id, classId }} />
    </Box>
  )
}

export default SessionsTab
